import { Link } from 'react-router-dom';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import TodayFocus from '@/pages/home/components/TodayFocus';
import LatestNewsList from '@/pages/home/components/LatestNewsList';
import FeaturedAnalyses from '@/pages/home/components/FeaturedAnalyses';
import BrandIntro from '@/pages/home/components/BrandIntro';
import { events } from '@/mocks/events';
import { statusText } from '@/utils/format';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Home() {
  usePageMeta({
    title: '51每日大赛-今日大赛资讯与往期黑5数据分析',
    description:
      '51每日大赛-今日大赛聚集地提供最新赛事信息、往期黑5数据统计及分析，涵盖各类比赛精彩内容，助力用户全面了解赛事动态。',
    keywords: '51每日大赛,今日大赛,比赛资讯,黑5往期数据,赛事分析,实时比赛信息,比赛聚集地',
  });

  const ticker = [...events].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const tickerItems = [...ticker, ...ticker];

  return (
    <>
      <HeroCarousel />

      <div className="w-full bg-primary-800 overflow-hidden">
        <div className="flex items-center">
          <span className="shrink-0 flex items-center gap-1.5 px-4 md:px-6 py-3 bg-accent-500 text-background-50 text-xs md:text-sm font-medium whitespace-nowrap">
            <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center" />
            赛事快讯
          </span>
          <div className="relative flex-1 overflow-hidden py-3">
            <div className="flex items-center gap-8 animate-ticker whitespace-nowrap">
              {tickerItems.map((item, i) => (
                <Link
                  key={`${item.id}-${i}`}
                  to={`/detail/${item.id}`}
                  className="flex items-center gap-2 text-xs md:text-sm text-primary-100 hover:text-accent-300 transition-colors"
                >
                  <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${item.status === 'live' ? 'bg-accent-400 animate-pulse-dot' : 'bg-primary-400'}`} />
                  <span className="font-medium">{item.league}</span>
                  <span>{item.homeTeam} vs {item.awayTeam}</span>
                  <span className="text-primary-300">{statusText(item.status)}</span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <CategoryQuickLinks />
      <TodayFocus />

      <section className="w-full px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2">
            <LatestNewsList />
          </div>
          <div className="lg:col-span-1 flex flex-col gap-5 md:gap-6">
            <FeaturedAnalyses />
            <div className="bg-background-100 border border-background-200 rounded-lg p-4 md:p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-950 flex items-center gap-2 mb-3">
                <i className="ri-trophy-line text-accent-600 w-5 h-5 flex items-center justify-center" />
                分类导航
              </h3>
              <div className="flex flex-wrap gap-2">
                {['足球', '篮球', '电竞', '网球', '棒球', '冰球'].map((name, i) => (
                  <Link
                    key={name}
                    to={`/category/${['football', 'basketball', 'esports', 'tennis', 'baseball', 'hockey'][i]}`}
                    className="px-3 py-1.5 rounded-full text-xs bg-background-50 border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    {name}
                  </Link>
                ))}
              </div>
              <Link
                to="/contact"
                className="mt-4 flex items-center justify-center gap-1.5 w-full px-4 py-2.5 rounded-md bg-primary-700 text-background-50 text-sm hover:bg-primary-800 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-send-line w-4 h-4 flex items-center justify-center" />
                提交反馈与建议
              </Link>
            </div>
          </div>
        </div>
      </section>

      <BrandIntro />
    </>
  );
}